/* ============================================================
   CUIDA DE TI — GLOBAL JS (reusable modules only)
   No page logic. No duplication of Dawn core.
   Pattern: small Web Components + a shared util namespace.
   Loaded with defer. Progressive enhancement: markup works
   without JS; these enhance it.
   ============================================================ */
(function () {
  'use strict';

  /* ---------- shared utils ---------- */
  window.CDT = window.CDT || {};

  CDT.prefersReducedMotion = function () {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  };

  CDT.trapFocus = function (container, firstFocus) {
    var focusables = container.querySelectorAll('a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])');
    if (!focusables.length) return function () {};
    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    function onKey(e) {
      if (e.key !== 'Tab') return;
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    container.addEventListener('keydown', onKey);
    (firstFocus || first).focus();
    return function release() { container.removeEventListener('keydown', onKey); };
  };

  /* ---------- reveal-on-scroll (opt-in via .cdt-reveal) ---------- */
  function initReveal() {
    var els = document.querySelectorAll('.cdt-reveal');
    if (!els.length) return;
    if (CDT.prefersReducedMotion() || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('cdt-is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('cdt-is-visible'); io.unobserve(entry.target); }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- <cdt-quantity> ---------- */
  if (!customElements.get('cdt-quantity')) {
    customElements.define('cdt-quantity', class extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('.cdt-qty__input');
        this.addEventListener('click', this.onClick.bind(this));
      }
      onClick(e) {
        var btn = e.target.closest('[data-cdt-qty]');
        if (!btn || !this.input) return;
        var step = btn.getAttribute('data-cdt-qty') === 'plus' ? 1 : -1;
        var min = parseInt(this.input.min || '1', 10);
        var val = parseInt(this.input.value || min, 10) + step;
        if (val < min) val = min;
        this.input.value = val;
        this.input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  /* ---------- <cdt-modal> ---------- */
  if (!customElements.get('cdt-modal')) {
    customElements.define('cdt-modal', class extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('.cdt-modal');
        this.release = null;
        var id = this.getAttribute('id');
        if (id) {
          document.querySelectorAll('[data-cdt-modal-open="' + id + '"]').forEach((t) => {
            t.addEventListener('click', (e) => { e.preventDefault(); this.open(); });
          });
        }
        this.addEventListener('click', (e) => {
          if (e.target.closest('[data-cdt-modal-close]') || e.target.classList.contains('cdt-modal__overlay')) this.close();
        });
        document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && this.isOpen()) this.close(); });
      }
      isOpen() { return this.dialog && this.dialog.classList.contains('cdt-is-open'); }
      open() {
        if (!this.dialog) return;
        this.opener = document.activeElement;
        this.dialog.classList.add('cdt-is-open');
        this.dialog.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        this.release = CDT.trapFocus(this.dialog);
      }
      close() {
        if (!this.dialog) return;
        this.dialog.classList.remove('cdt-is-open');
        this.dialog.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        if (this.release) this.release();
        if (this.opener) this.opener.focus();
      }
    });
  }

  /* ---------- init ---------- */
  if (document.readyState !== 'loading') initReveal();
  else document.addEventListener('DOMContentLoaded', initReveal);
  document.addEventListener('shopify:section:load', initReveal); // theme editor re-init
})();
